import {fetchCycles, fetchCPTList} from "../network/InductNetworkAPI";

export const InductFilterReducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_CYCLE':
            fetchCycles(action.data.dispatcher)
            return state
        case 'RECEIVE_CYCLE':
            return {...state, allCycles: action.data.cycles}
        case 'SELECT_CYCLE':
            return {...state, selectedCycles: action.data.cycles};
        case 'CLEAR_ALL_CYCLE':
            return {...state, selectedCycles: []};
        case 'CLEAR_CYCLE':
            const selectedCycles = removeCycle(state.selectedCycles, action.data.cycleId)
            return {...state, selectedCycles: selectedCycles}
        case 'FETCH_CPT':
            fetchCPTList(action.data.dispatcher)
            return state
        case 'RECEIVE_CPT':
            return {...state, allCPT: action.data.CPT}
        case 'SELECT_CPT':
            return {...state, selectedCPT: action.data.CPT};
        case 'CLEAR_ALL_CPT':
            return {...state, selectedCPT: []};
        case 'CLEAR_CPT':
            const selectedCPT = removeCPT(state.selectedCPT, action.data.CPT)
            return {...state, selectedCPT: selectedCPT}
        case 'ASSIGN_LABEL':
            return {...state, CPTLabel: action.data.CPTLabel}
        case 'ASSIGN_FILTER_IDENTIFIER':
            return {...state, filterIdentifier: action.data.filterIdentifier}
        default:
            return state;
    }
}

const removeCycle = (cycles, id) => {
    const selectedCycles = cycles
    const index = selectedCycles.indexOf(id)
    if (index > -1) {
        selectedCycles.splice(index, 1)
    }
    return selectedCycles
}

const removeCPT = (selectedCPTs, CPT) => {
    const selectedCPT = selectedCPTs
    const index = selectedCPT.map(function(CPTDetail) { return CPTDetail.id }).indexOf(CPT.id);
    if (index > -1) {
        selectedCPT.splice(index, 1)
    }
    return selectedCPT
}


// WEBPACK FOOTER //
// ./src/components/induct/reducers/InductFilterReducer.js